import { render, staticRenderFns } from "./GlobalY.vue?vue&type=template&id=4d437e38&scoped=true&"
import script from "./GlobalY.vue?vue&type=script&lang=js&"
export * from "./GlobalY.vue?vue&type=script&lang=js&"
import style0 from "./GlobalY.vue?vue&type=style&index=0&id=4d437e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d437e38",
  null
  
)

export default component.exports